import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Tenant } from "../models/tenant";
import { DataService } from "../../core/data.service";
import { ODataResponse } from '../models/odata-response';
import { AppConfigService } from 'src/app/core/app-config.service';

@Injectable({
  providedIn: "root",
})
export class TenantDataService extends DataService<Tenant> {
  constructor(http: HttpClient, acs: AppConfigService) {
    super(http, "Tenants", acs);
  }

  tenantCount(
    tenantId: number,
    code: string
  ) {
    let url = `${this.acs.current.configApiUrl}odata/Tenants?$filter=Code eq '${code}' and Id ne ${tenantId}&$count=true&$top=0`;
    return this.http.get<ODataResponse<Tenant>>(url);
  }   
}
